document.addEventListener('DOMContentLoaded', function () {
    const calculatorElements = document.querySelector('.calculator-section, .calculator-container, #amount-from, #amount-to');
    if (!calculatorElements) {
        return;
    }

    let exchangeRates = {};
    let lastFetchTime = 0;
    let isInitialized = false;

    const btn = document.querySelector(".btn-more-currencies");
    const list = document.querySelector(".rates-list");
    const container = document.querySelector(".rates-container");
    const amountFrom = document.getElementById('amount-from');
    const amountTo = document.getElementById('amount-to');
    const fromSelector = document.querySelector('[data-dropdown="from"]');
    const toSelector = document.querySelector('[data-dropdown="to"]');
    const currencySelectors = document.querySelectorAll('.currency-selector');

    let currentFromCurrency = 'PLN';
    let currentToCurrency = 'EUR';

    function updateToCurrencyDropdown() {
        const toDropdown = toSelector.querySelector('.currency-dropdown');
        const toDisplay = toSelector.querySelector('.currency-display');
        const allOptions = toDropdown.querySelectorAll('.currency-option');

        if (currentFromCurrency === 'PLN') {
            allOptions.forEach(option => {
                option.style.pointerEvents = 'auto';
                option.style.opacity = '1';
                option.style.cursor = 'pointer';
            });
            toSelector.style.pointerEvents = 'auto';
            toSelector.style.cursor = 'pointer';
            toSelector.classList.remove('disabled');
        } else {
            const plnOption = Array.from(allOptions).find(opt => opt.dataset.currency === 'PLN');

            if (plnOption) {
                const img = plnOption.querySelector('.flag-icon');
                toDisplay.querySelector('.flag-icon').src = img.src;
                toDisplay.querySelector('.flag-icon').alt = img.alt;
                toDisplay.querySelector('.currency-code').textContent = 'PLN';

                allOptions.forEach(x => x.classList.remove('active'));
                plnOption.classList.add('active');

                currentToCurrency = 'PLN';

                allOptions.forEach(option => {
                    if (option.dataset.currency !== 'PLN') {
                        option.style.pointerEvents = 'none';
                        option.style.opacity = '0.5';
                        option.style.cursor = 'not-allowed';
                    } else {
                        option.style.pointerEvents = 'auto';
                        option.style.opacity = '1';
                        option.style.cursor = 'pointer';
                    }
                });

                toSelector.style.pointerEvents = 'auto';
                toSelector.classList.add('disabled');
            }
        }
    }

    if (btn && list && container) {
        btn.innerHTML = '<span>Pozostałe waluty</span> <img src="/assets/images/arrow_yellow_down.png" class="arrow-toggle" alt="">';
        list.classList.add("collapsed");

        btn.addEventListener("click", () => {
            const isCollapsed = list.classList.contains("collapsed");
            if (isCollapsed) {
                list.classList.remove("collapsed");
                container.classList.add("expanded");
                btn.classList.add("expanded");
                btn.querySelector('span').textContent = 'Zwiń waluty';
            } else {
                list.classList.add("collapsed");
                container.classList.remove("expanded");
                btn.classList.remove("expanded");
                btn.querySelector('span').textContent = 'Pozostałe waluty';
            }
        });
    }

    currencySelectors.forEach(selector => {
        const display = selector.querySelector('.currency-display');
        const dropdown = selector.querySelector('.currency-dropdown');
        const options = selector.querySelectorAll('.currency-option');

        if (!display || !dropdown) return;

        display.addEventListener('click', e => {
            if (selector.classList.contains('disabled') && selector.dataset.dropdown === 'to' && currentFromCurrency !== 'PLN') {
                e.stopPropagation();
                return;
            }

            e.stopPropagation();
            currencySelectors.forEach(other => {
                if (other !== selector) other.classList.remove('active');
            });
            selector.classList.toggle('active');
        });

        options.forEach(opt => {
            opt.addEventListener('click', e => {
                if (opt.style.pointerEvents === 'none') {
                    e.stopPropagation();
                    return;
                }

                e.stopPropagation();
                const cur = opt.dataset.currency;
                const img = opt.querySelector('.flag-icon');
                display.querySelector('.flag-icon').src = img.src;
                display.querySelector('.flag-icon').alt = img.alt;
                display.querySelector('.currency-code').textContent = cur;
                options.forEach(x => x.classList.remove('active'));
                opt.classList.add('active');
                selector.classList.remove('active');

                const event = new CustomEvent('currencyChange', {
                    detail: {currency: cur, type: selector.dataset.dropdown}
                });
                document.dispatchEvent(event);
            });
        });
    });

    document.addEventListener('click', () => {
        currencySelectors.forEach(sel => sel.classList.remove('active'));
    });

    async function fetchExchangeRates() {
        try {
            const response = await fetch('ajax.php?getExchangeRates=1');

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data && typeof data === 'object') {
                if (data.EUR && typeof data.EUR === 'object' && data.EUR.buy !== undefined) {
                    exchangeRates = data;
                } else if (Array.isArray(data)) {
                    exchangeRates = convertBackendToFrontendFormat(data);
                } else if (data.data && Array.isArray(data.data)) {
                    exchangeRates = convertBackendToFrontendFormat(data.data);
                } else {
                    exchangeRates = data;
                }

                lastFetchTime = Date.now();

                try {
                    localStorage.setItem('exchangeRates', JSON.stringify(exchangeRates));
                    localStorage.setItem('exchangeRatesTime', lastFetchTime.toString());
                } catch (e) {
                }

                return exchangeRates;
            } else {
                throw new Error('Nieprawidłowy format danych z pliku JSON');
            }
        } catch (error) {
            return await loadFromFallback();
        }
    }

    async function loadFromFallback() {
        try {
            const savedRates = localStorage.getItem('exchangeRates');
            const savedTime = localStorage.getItem('exchangeRatesTime');

            if (savedRates && savedTime) {
                const timeDiff = Date.now() - parseInt(savedTime);
                if (timeDiff < 2 * 60 * 60 * 1000) {
                    exchangeRates = JSON.parse(savedRates);
                    return exchangeRates;
                }
            }
        } catch (e) {
        }

        try {
            const response = await fetch('ajax.php?getExchangeRates=1');
            if (response.ok) {
                const data = await response.json();
                exchangeRates = data;
                return exchangeRates;
            }
        } catch (ajaxError) {
        }

        if (Object.keys(exchangeRates).length === 0) {
            exchangeRates = getDefaultRates();
        }

        return exchangeRates;
    }

    function getDefaultRates() {
        return {
            EUR: { buy: 4.30, sell: 4.45, ave: 4.375, diff: 0, dayDiff: 0, percent: 0 },
            USD: { buy: 3.95, sell: 4.10, ave: 4.025, diff: 0, dayDiff: 0, percent: 0 },
            GBP: { buy: 5.10, sell: 5.25, ave: 5.175, diff: 0, dayDiff: 0, percent: 0 },
            CHF: { buy: 4.35, sell: 4.50, ave: 4.425, diff: 0, dayDiff: 0, percent: 0 }
        };
    }

    function convertBackendToFrontendFormat(backendData) {
        const converted = {};

        backendData.forEach(currency => {
            if (currency.Symbol) {
                const symbol = currency.Symbol;
                const buy = parseFloat(currency.Buy) || 0;
                const sell = parseFloat(currency.Sale) || 0;
                const buyStationary = parseFloat(currency.BuyStationary) || 0;

                converted[symbol] = {
                    buy: buy,
                    sell: sell,
                    ave: (buy + sell) / 2,
                    diff: parseFloat(currency.BuyChange) || 0,
                    dayDiff: buy - buyStationary,
                    percent: buyStationary > 0 ? ((buy - buyStationary) / buyStationary) * 100 : 0
                };
            }
        });

        return converted;
    }

    function getExchangeRate(fromCurrency, toCurrency) {
        if (!isInitialized || Object.keys(exchangeRates).length === 0) {
            const defaultRates = getDefaultRates();
            return calculateWithRates(defaultRates, fromCurrency, toCurrency);
        }

        return calculateWithRates(exchangeRates, fromCurrency, toCurrency);
    }

    function calculateWithRates(rates, fromCurrency, toCurrency) {
        if (fromCurrency === toCurrency) return 1;

        if (fromCurrency === 'PLN') {
            const currencyData = rates[toCurrency];
            if (!currencyData || currencyData.sell <= 0) {
                return 0;
            }
            return 1 / currencyData.sell;
        } else if (toCurrency === 'PLN') {
            const currencyData = rates[fromCurrency];
            if (!currencyData || currencyData.buy <= 0) {
                return 0;
            }
            return currencyData.buy;
        } else {
            const fromData = rates[fromCurrency];
            const toData = rates[toCurrency];

            if (!fromData || !toData) {
                return 0;
            }

            if (fromData.buy <= 0 || toData.sell <= 0) {
                return 0;
            }

            const fromToPLN = fromData.buy;
            const PLNtoTo = 1 / toData.sell;
            return fromToPLN * PLNtoTo;
        }
    }

    function formatNumber(number, decimals = 2) {
        if (isNaN(number) || !isFinite(number)) return '0.00';

        return number.toLocaleString('pl-PL', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    async function calculateExchange() {
        const amount = parseFloat(amountFrom.value) || 0;
        if (amount <= 0) {
            amountTo.value = '';
            return;
        }

        const rate = getExchangeRate(currentFromCurrency, currentToCurrency);

        if (rate <= 0) {
            amountTo.value = 'Brak kursu';
            return;
        }

        const result = amount * rate;
        const decimals = currentToCurrency === 'JPY' ? 0 : 2;
        amountTo.value = formatNumber(result, decimals);
    }

    async function updateRateDisplay() {
        const rate = getExchangeRate(currentFromCurrency, currentToCurrency);
        const rateDisplay = document.querySelector('.exchange-rate-display');
        if (rateDisplay) {
            if (rate <= 0) {
                rateDisplay.textContent = `Ładowanie kursów...`;
                rateDisplay.style.color = '#ff6b6b';
            } else {
                const decimals = currentToCurrency === 'JPY' ? 4 : 4;
                rateDisplay.textContent = `1 ${currentFromCurrency} = ${formatNumber(rate, decimals)} ${currentToCurrency}`;
                rateDisplay.style.color = '';
            }
        }
    }

    function showLoadingState(show = true) {
        if (show) {
            amountTo.value = 'Ładowanie kursów...';
            amountTo.style.opacity = '0.6';
        } else {
            amountTo.style.opacity = '1';
        }
    }

    function updateUIAfterRatesLoad() {
        calculateExchange();
        updateRateDisplay();
        updateCurrencyDropdowns();
    }

    function updateCurrencyDropdowns() {
        const availableCurrencies = Object.keys(exchangeRates);
    }

    amountFrom.addEventListener('input', calculateExchange);

    document.addEventListener('currencyChange', function (e) {
        const {currency, type} = e.detail;
        if (type === 'from') {
            currentFromCurrency = currency;
            updateToCurrencyDropdown();
        } else if (type === 'to') {
            currentToCurrency = currency;
        }
        calculateExchange();
        updateRateDisplay();
    });

    amountFrom.addEventListener('keypress', function (e) {
        const char = String.fromCharCode(e.which);
        const value = e.target.value;

        if (char === ',') {
            e.preventDefault();
            if (!value.includes('.')) {
                e.target.value += '.';
            }
            return;
        }

        if (!/[\d.]/.test(char)) {
            e.preventDefault();
            return;
        }

        if (char === '.' && value.includes('.')) {
            e.preventDefault();
            return;
        }

        if (value.includes('.')) {
            const decimals = value.split('.')[1];
            if (decimals && decimals.length >= 2) {
                e.preventDefault();
            }
        }
    });

    amountFrom.addEventListener('paste', function (e) {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        const sanitized = paste.replace(',', '.').replace(/[^\d.]/g, '');
        if (!isNaN(parseFloat(sanitized))) {
            e.target.value = sanitized;
            calculateExchange();
        }
    });

    (async function init() {
        showLoadingState(true);
        await fetchExchangeRates();
        isInitialized = true;
        showLoadingState(false);
        updateToCurrencyDropdown();
        updateUIAfterRatesLoad();
    })();

    setInterval(async function () {
        await fetchExchangeRates();
        updateUIAfterRatesLoad();
    }, 15000);

    window.refreshExchangeRates = function () {
        fetchExchangeRates().then(() => {
            updateUIAfterRatesLoad();
        });
    };

    window.getCurrentRates = () => exchangeRates;
});